import { getFilterOptions, getFormatExample, SearchType } from './config/searchConfig';

export const filterOptions = {
  DISEASES: getFilterOptions('DISEASES').map(f => ({ value: f.value, label: f.label })),
  VARIANTS: getFilterOptions('VARIANTS').map(f => ({ value: f.value, label: f.label })),
  GENES: getFilterOptions('GENES').map(f => ({ value: f.value, label: f.label })),
  CHEMICALS: getFilterOptions('CHEMICALS').map(f => ({ value: f.value, label: f.label })),
};
export const renderFilterOptions = (
  searchType: string,
  selectedFilter: string,
  setSelectedFilter: (filter: string) => void,
) => {
  const currentFilters = filterOptions[searchType as SearchType] || [];

  return (
    <select
      name="filter"
      value={selectedFilter}
      onChange={e => setSelectedFilter(e.target.value)}
      className="custom-dropdown"
    >
      {currentFilters.map(filter => (
        <option key={filter.value} value={filter.value}>
          {filter.label}
        </option>
      ))}
    </select>
  );
};

export const getExpectedFormatMessage = (searchType: string, selectedFilter: string): string => {
  return getFormatExample(searchType as SearchType, selectedFilter);
};

export const getMsg = (searchType: string, selectedFilter: string): string => {
  const messages: Record<string, Record<string, string>> = {
    DISEASES: {
      diseaseUMLSCUI: 'CUI',
      MSH: 'MESH',
    },
    VARIANTS: {
      strID: 'rs number',
    },
    GENES: {
      symbol: 'Symbol',
    },
    CHEMICALS: {
      CHEMBL: 'CUI',
    },
  };

  return messages[searchType]?.[selectedFilter] || '';
};

export const getItemCount = (text: string): number =>
  text.split('\n').filter(line => line.trim() !== '').length;

const VALIDATION_PATTERNS: Record<string, Record<string, RegExp>> = {
  DISEASES: {
    diseaseUMLSCUI: /^[A-Za-z0-9]{7,8}$/,
    name: /^[\p{L}\s\-'.,]+$/u,
    MSH: /^[A-Za-z0-9]{7,8}$/,
    OMIM: /^\d{5,6}$/,
    NCI: /^C\d{5,6}$/,
    EFO: /^\d{7}$/,
    DO: /^(?:DO[_:]?)?\d+$/i,
    ORDO: /^\d{3}$/,
    HPO: /^HP:\d{7}$/,
    MONDO: /^\d{7}$/,
  },
  VARIANTS: {
    strID: /^.*$/i,
    chromocoord: /^\d+:\d+$/,
    proteinStrID: /^[A-Z0-9]+\s+[A-Z][a-z]{2}\d+[A-Z][a-z]{2}$|^[A-Z0-9]+\s+[A-Z]\d+[A-Z]$/,
    hgvsc: /^ENST\d+\.\d+:c\.[A-Za-z0-9_+\-*>?=()]+$/,
    hgvsp: /^ENSP\d+\.\d+:p\.[A-Za-z0-9_+\-*>?=()]+$/,
  },
  GENES: {
    symbol: /^(?!rs\d)[A-Z][A-Za-z0-9-]{0,19}$/,
    geneSymbol: /^(?!rs\d)[A-Z][A-Za-z0-9-]{0,19}$/,
    geneID: /^\d+$/,
    geneId: /^\d+$/,
    ensemblID: /^ENSG\d{11}$/,
    ensemblId: /^ENSG\d{11}$/,
    uniprotID: /^(?:[OPQ][0-9][A-Z0-9]{3}[0-9]|[A-NR-Z][0-9]([A-Z][A-Z0-9]{2}[0-9]){1,2})$/i,
    uniprotId: /^(?:[OPQ][0-9][A-Z0-9]{3}[0-9]|[A-NR-Z][0-9]([A-Z][A-Z0-9]{2}[0-9]){1,2})$/i,
    name: /^(?!rs\d)(?!ensembl)(?!ensg)(?![PQ][A-Z0-9]{5}$)\p{L}[\p{L}0-9\- ]{1,49}$/iu,
  },
  CHEMICALS: {
    name: /^[\p{L}\s\-'.,]+$/u,
    CHEBI: /^[0-9]+$/,
    DRUGBANK: /^[A-Za-z0-9_-]+$/,
    MESH: /^[A-Za-z0-9_-]+$/,
    CHEMBL: /^[A-Za-z0-9_-]+$/,
    PUBCHEM: /^[0-9]+$/,
  },
};

export const validateInput = (input: string, searchType: string, selectedFilter: string): boolean => {
  const pattern = VALIDATION_PATTERNS[searchType]?.[selectedFilter];

  if (!pattern) {
    return false;
  }

  if (searchType === 'DISEASES' && selectedFilter === 'name') {
    if (/^C\d{7}$/.test(input)) {
      return false;
    }
  }

  if (searchType === 'CHEMICALS' && selectedFilter === 'name') {
    if (/^C\d{7}$/.test(input)) {
      return false;
    }
  }

  return pattern.test(input);
};
